module.exports = __webpack_public_path__ + "pc/img/magazine_detail_img01.f0d5d713.jpg";